"use strict";
export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK.Interfaces/IChannelControls.js
// module id = ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK.Interfaces/IChannelControls.js
// module chunks = vendor